import React, { useState } from "react";
import { useMutation } from '@apollo/client';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { INVITE_PARTNER } from '../../GraphQL/settings/mutations';

interface Props {
  show: boolean;
  onHide: () => void;
}

const InvitePartnerModal = ({
 show, onHide
}: Props) => {
  const [email, setEmail] = useState<string>("");
  const [invitePartner] = useMutation(INVITE_PARTNER);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  }

  const handleSubmit = async () =>  {
    const valid = email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
    if(!valid){
      alert("Please enter a valid email address");
      return;
    }

    try {
      await invitePartner({ variables: { email: email } });
      alert("Partner invited successfully");
      onHide();
    }catch(err){
      console.log(err);
      alert("Something went wrong, please try again soon");
      onHide();
    }
  }


  return (
    <Dialog open={show} onOpenChange={(open) => !open && onHide()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite a partner</DialogTitle>
        </DialogHeader>
        <div>
          <p>
            Enter the email address of someone you would like to partner with.
            Agencies will be able to see roles and candidates that have been
            specifically shared with their partners.
          </p>
          <div className="space-y-2">
            <Label htmlFor="email">Email*</Label>
            <Input id="email" type="email" onChange={handleEmailChange} required />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={handleSubmit}>
            Send
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InvitePartnerModal;
